import decode from 'jwt-decode';
import BrowserCookies from './BrowserCookies';

export default function getUserId(
  cookieValue = BrowserCookies.get('CVAccessToken')
) {
  if (!cookieValue) return undefined;

  try {
    const { access_token: accessToken = '' } = JSON.parse(cookieValue || '{}');
    const decodedToken = decode(accessToken);
    const isExpired = decodedToken.exp * 1000 < Date.now();

    return isExpired ? undefined : decodedToken.sub;
  } catch (e) {
    return undefined;
  }
}
